import script from "./CheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckBox.vue?vue&type=script&setup=true&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=68907c4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68907c4e"]])

export default __exports__